import React from 'react';
import { Box, Typography } from '@mui/material';

/** A read-only value with its label. */
const InfoField: React.FC<{ label: string; value?: React.ReactNode; hint?: React.ReactNode; multiline?: boolean }> = ({ label, value, hint, multiline }) => (
  <Box sx={{ minWidth: 0 }}>
    <Typography variant="caption" color="text.secondary" component="div">{label}</Typography>
    <Typography variant="body2" component="div" sx={{ wordBreak: 'break-word', whiteSpace: multiline ? 'pre-line' : undefined }}>
      {value === null || value === undefined || value === '' ? '—' : value}
    </Typography>
    {hint ? <Typography variant="caption" color="text.secondary" component="div">{hint}</Typography> : null}
  </Box>
);

export default InfoField;
